import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { useQuery } from '@apollo/client';
import { useSearchParams } from 'react-router-dom';

import DataState from 'app/src/components/DataState';
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { elGray } from 'app/src/styles/colors';

import { REPORT_REGISTRY } from './reportRegistry';
import { REPORT_FILTERS } from './queries';

const REPORT_PARAM = 'report';

const Reports = () => {
  const { data, loading, error } = useQuery(REPORT_FILTERS);
  const [searchParams, setSearchParams] = useSearchParams();

  if (loading || !data) return <DataState.Loading />;
  if (error) return <DataState.Error error={error} />;

  const selectedValue = searchParams.get(REPORT_PARAM) || '';
  const selectedReport =
    REPORT_REGISTRY.find(report => report.value === selectedValue);

  const changeReport = value => {
    setSearchParams(value ? { [REPORT_PARAM]: value } : {});
  };

  return (
    <View style={styles.container}>
      <View style={cardStyles.container}>
        <Text style={cardStyles.title}>Reports</Text>
        <Text style={cardStyles.label}>Report:</Text>
        <SearchableSelect
          placeholder="Select Report"
          options={REPORT_REGISTRY.map(({ value, label }) => ({ value, label }))}
          value={selectedValue}
          onChange={changeReport}
        />
      </View>
      {selectedReport && <selectedReport.Component data={data} />}
    </View>
  );
};

export const styles = StyleSheet.create({
  container: {
    marginTop: 20,
    backgroundColor: elGray,
    marginBottom: 20,
    marginLeft: 20,
    marginRight: 20,
  },
});

export const cardStyles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderColor: 'black',
    padding: 10,
    minWidth: 600,
  },
  title: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
  },
  note: {
    color: 'red',
    fontWeight: 800,
    marginBottom: 10,
  },
  label: {
    fontSize: 16,
    marginBottom: 5,
  },
  select: {
    borderWidth: 1,
    borderColor: 'gray',
    borderRadius: 5,
    marginBottom: 10,
    paddingHorizontal: 5,
    height: 25,
  },
});

export default Reports;
